import React from 'react'
import { listenAuthState } from './reducks/users/operations'
import { useDispatch, useSelector } from 'react-redux'
import { getSignedIn, getUserInfo } from './reducks/users/selectors'
import { useEffect } from 'react'
import { db } from './firebase'
import { collection, onSnapshot, query, where } from 'firebase/firestore'
import { signInAction } from './reducks/users/actions'

// アプリのゲートは isSignedIn のみで判定する。
// (Gmail送信用トークンは発注メール送信時にオンデマンド取得するため、
//  アプリの利用可否には関与しない。)
const Auth = ({ children }) => {
  const dispatch = useDispatch()
  const isSignedIn = useSelector(getSignedIn)
  const userInfo = useSelector(getUserInfo)

  useEffect(() => {
    if (!isSignedIn) {
      dispatch(listenAuthState())
    }
  }, [])

  // ログインユーザのプロフィール変更をリアルタイムに反映する。
  useEffect(() => {
    if (!userInfo || !userInfo.email) return
    const targetUserEmail = userInfo.email
    const usersRef = collection(db, 'users')
    const q = query(usersRef, where('email', '==', targetUserEmail))

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const updatedUsers = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))

      if (updatedUsers.length > 0) {
        const userData = updatedUsers[0]

        // 必須フィールドの検証（ネットワーク不安定時の不完全なデータを検出）
        const requiredFields = [
          'email',
          'uid',
          'username',
          'usernumber',
          'departmentid',
          'departmentname',
          'role',
        ]

        const hasAllRequiredFields = requiredFields.every((field) => {
          const value = userData[field]
          return value !== undefined && value !== null && value !== ''
        })

        if (hasAllRequiredFields) {
          dispatch(signInAction(userData))
        } else {
          const missingFields = requiredFields.filter((field) => {
            const value = userData[field]
            return value === undefined || value === null || value === ''
          })
          console.warn(
            '不完全なユーザーデータを受信しました。更新をスキップします。',
            {
              userData,
              missingFields,
            }
          )
          // 不完全なデータの場合は既存のstateを保持（何もdispatchしない）
        }
      }
    })

    // コンポーネントのアンマウント時にリスナーを解除
    return () => unsubscribe()
  }, [dispatch, userInfo.uid])

  if (!isSignedIn) {
    return <></>
  }
  return children
}

export default Auth
